module.exports = (myField, myValue) => {
    var hadFocus = (typeof $(myField).data('no-focus-yet') === 'undefined');
    myField.focus();
    if (document.selection) {
        myField.focus();
        sel = document.selection.createRange();
        sel.text = myValue;
    }
    //MOZILLA and others
    else if (myField.selectionStart || myField.selectionStart == '0') {
        if (!hadFocus) {
          myField.value += myValue;
          setCaretPosition(myField, myField.value.length + myValue.length);
          return;
        }

        var startPos = myField.selectionStart;
        var endPos = myField.selectionEnd;
        myField.value = myField.value.substring(0, startPos)
            + myValue
            + myField.value.substring(endPos, myField.value.length);
        myField.selectionStart = startPos + myValue.length;
        myField.selectionEnd = startPos + myValue.length;
        setCaretPosition(myField, myField.selectionEnd);
    } else {
        setCaretPosition(myField, myField.value.length + myValue.length);
        myField.value += myValue;
    }
}

function setCaretPosition(elem, caretPos) {
    if(elem != null) {
        if(elem.createTextRange) {
            var range = elem.createTextRange();
            range.move('character', caretPos);
            range.select();
        }
        else {
            if(elem.selectionStart) {
                elem.focus();
                elem.setSelectionRange(caretPos, caretPos);
            }
            else
                elem.focus();
        }
    }
}
